import React from "react";
import {oneOf, string} from "prop-types";
import "./index.scss";

function Title(props) {
    const {size, children, className} = props;
    const align = props.align || "left";
    return <h1 className={`title size${size} align-${align} ${className}`}>{children}</h1>
}

Title.propTypes = {
    size: oneOf([60, 48, 34, 28, 24, 20, 18, 16, 14, 12, 10]).isRequired,
    align: oneOf(["center", "right", "left"]),
    className: string
}

export default Title;